import { render, staticRenderFns } from "./searchProduct.vue?vue&type=template&id=3ad72f9e"
import script from "./searchProduct.vue?vue&type=script&lang=js"
export * from "./searchProduct.vue?vue&type=script&lang=js"
import style0 from "./searchProduct.vue?vue&type=style&index=0&id=3ad72f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports